import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, postData, putData } from 'src/utils/axios/serverHelper';
import { MST3010_R01Dto } from './Dto_MST3010_R01';
import { MST3010_R01Filter } from "./Store_MST3010_R01";

const baseUrl = `${config.apiUrl}/MST3010_R01`;

// 작업장 목록 조회 (GET) - 공정명 검색만
export const getMST3010_R01List = async (option: string, params: Partial<MST3010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<MST3010_R01Dto[]>>(url,  { params: { ...params, listLength } });
}

export const getMST3010_R01AllCount = async (params: Partial<MST3010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

export const getMST3010_R01One = async (workplaceCd: string) => {
	const url = `${baseUrl}/one/${workplaceCd}`;
	
	return await getData<ResponseDto<MST3010_R01Dto>>(url);
}

// 작업장 등록 (POST)
export const createMST3010_R01 = async (data: MST3010_R01Dto) => {
	// console.log('작업장 등록 API 호출 URL:', baseUrl);
	// console.log('등록 데이터:', data);
	return await postData<MST3010_R01Dto, ResponseDto<MST3010_R01Dto[]>>(`${baseUrl}`, data);
}

// 작업장 수정 (PUT)
export const updateMST3010_R01 = async (data: MST3010_R01Dto) => {
	// console.log('작업장 수정 API 호출 URL:', baseUrl);
	// console.log('수정 데이터:', data);
	return await putData<MST3010_R01Dto, ResponseDto<MST3010_R01Dto[]>>(`${baseUrl}`, data);
}

// 작업장 삭제 (DELETE)
export const deleteMST3010_R01 = async (workplaceCd: string) => {
	// console.log('작업장 삭제 API 호출 URL:', `${baseUrl}/${workplaceCd}`);
	return await deleteData<ResponseDto<any>>(`${baseUrl}/${workplaceCd}`);
}

// 엑셀 다운로드 (GET)
export const downloadExcel_MST3010_R01 = async (option: string, params: Partial<MST3010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url,  { params: { ...params, listLength } });
} 